module.exports = __webpack_public_path__ + "static/logo-white-1084142879bfe4a05bde56316642a17d.svg";